import { useEffect } from "react";

const SITE = "Élégance Noire & Lumière";

export function useMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} — ${SITE}` : SITE;
    let tag = document.querySelector('meta[name="description"]');
    const prevDesc = tag?.getAttribute("content");
    if (description) {
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = "description";
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    return () => {
      document.title = prevTitle;
      if (tag && prevDesc != null) tag.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
